class Tabs {
	constructor(tubs) {
		this.tubs = tubs;
		this.tubs = this.tubs.querySelectorAll('.js-tab');
		this.init();
	}

	init() {
		// почему возникает ошибка при вызове this.tubs в цикле foreach this.tubs
		const tubs = this.tubs;

		tubs.forEach((item) => {
			item.addEventListener('click', function () {
				tubs.forEach((it) => {
					it.classList.remove('active');
				});

				this.classList.add('active');
			});
		});
	}
}

document.querySelectorAll('.js-tabs').forEach((it) => {
	new Tabs(it);
});

function init() {
	document.querySelectorAll('.js-tabs').forEach((it) => {
		new Tabs(it);
	});
}

export default {
	init,
};

